// tr strings for messages/pricing.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const pricing: Dict = {
  "pricing.promo": "İlk ayın {price} fiyatından başlıyor",
  "pricing.title": "İstediğin sesle cover yap",
  "pricing.subtitle":
    "Sınırsız cover, indirme ve 93.000+ sesin tamamı. İstediğin zaman iptal et.",
  "pricing.trialLinkInvalid":
    "Bu ücretsiz deneme bağlantısı başka bir hesaba ait ya da süresi dolmuş — normal ödeme sayfası gösteriliyor.",

  "pricing.basic.subtitle": "Cover yapmak için",
  "pricing.creator.subtitle": "Videolar ve kendi seslerin için",
  "pricing.power.subtitle": "Yoğun kullanım ve geliştiriciler için",
  "pricing.badge.popular": "En popüler",

  "pricing.feature.unlimitedCovers": "Sınırsız cover",
  "pricing.feature.download": "Cover'ı, vokalleri ve müziği indir",
  "pricing.feature.library": "Ses kütüphanesinin tamamı",
  "pricing.feature.tts": "Metinden sese",
  "pricing.feature.duets": "Düetler",
  "pricing.feature.credits": "Krediler asla sona ermez",
  "pricing.feature.train": "Sınırsız ses eğit",
  "pricing.feature.videos": "Paylaşılabilir videolar: Marble Run ve sözlü",
  "pricing.feature.coins50": "Her ay 50 video jetonu",
  "pricing.feature.priority": "Öncelikli işleme, 12 saatte 250",
  "pricing.feature.coinsUnlimited": "Sınırsız video jetonu",
  "pricing.feature.api": "Her ay $25 API kredisi",

  "pricing.compareAll": "Hepsini karşılaştır",
  "pricing.trust.cancel": "İstediğin zaman iptal et, yaptıkların sende kalsın",
  "pricing.trust.stripe": "Stripe ile güvenli ödeme",
  "pricing.trust.currency": "Fiyatlar kendi para biriminde",

  "pricing.compare.title": "Planları karşılaştır",
  "pricing.compare.noPlan": "Plan yok",
  "pricing.compare.browse": "Tüm sesleri keşfet ve dinle",
  "pricing.compare.covers": "Cover'lar",
  "pricing.compare.downloads": "İndirmeler",
  "pricing.compare.ttsDuets": "Metinden sese ve düetler",
  "pricing.compare.song": "Yapay zeka ile şarkı oluştur",
  "pricing.compare.train": "Kendi seslerini eğit",
  "pricing.compare.videos": "Videolar (Marble Run, sözlü)",
  "pricing.compare.priority": "Öncelikli işleme",
  "pricing.compare.api": "API kredisi",
  "pricing.compare.unlimited": "Sınırsız",
  "pricing.compare.coins50": "Ayda 50 jeton",
  "pricing.compare.priorityLimit": "12 saatte 250",
  "pricing.compare.apiAmount": "Ayda $25",

  "pricing.faq.title": "Sorular",
  "pricing.faq.noPlan.q": "Plan olmadan ne yapabilirim?",
  "pricing.faq.noPlan.a":
    "Jammable'daki tüm sesleri keşfedebilir ve dinleyebilirsin. Cover yapmak, indirmek, metinden sese ve düetler için plan gerekir.",
  "pricing.faq.basic.q": "Basic planda neler var?",
  "pricing.faq.basic.a":
    "Basic planda sınırsız cover, indirme, Jammable ses kütüphanesinin tamamına erişim, metinden sese ve düetler var; kredilerin de asla sona ermez.",
  "pricing.faq.creator.q": "Creator planın Basic'ten farkı ne?",
  "pricing.faq.creator.a":
    "Creator planı Basic'teki her şeyi sunar; buna ek olarak sınırsız ses eğitebilir, paylaşılabilir videolar oluşturabilir ve her ay 50 Marble Run jetonu alırsın.",
  "pricing.faq.power.q": "Power planı özel kılan ne?",
  "pricing.faq.power.a":
    "Power, Creator'daki her şeyi içerir; buna ek olarak profesyonel içerik üreticileri için öncelikli işleme (12 saatte 250), sınırsız Marble Run jetonu ve her ay $25 API kredisi sunar.",
  "pricing.faq.cancel.q": "Aboneliğimi istediğim zaman iptal edebilir miyim?",
  "pricing.faq.cancel.a":
    "Evet, istediğin zaman iptal edebilirsin. Avantajların fatura döneminin sonuna kadar aktif kalır.",
  "pricing.faq.change.q": "Planımı yükseltebilir veya düşürebilir miyim?",
  "pricing.faq.change.a":
    "Kesinlikle. İstediğin zaman planını yükselt veya düşür, avantajların buna göre güncellenir.",

  // Shown after the big price: "<price> aylık", "<price> yıllık, ...".
  "pricing.card.perYear": "yıllık, ayda yaklaşık {price}",
  "pricing.card.firstMonthThen": "ilk ay, sonra ayda {price}",
  "pricing.card.perMonth": "aylık",
  "pricing.card.startFor": "{price} ile başla",
  "pricing.card.everythingIn": "{plan} planındaki her şey, artı",
  "pricing.cta.get": "{plan} planını al",
  "pricing.cta.yourPlan": "Mevcut planın",
  "pricing.cta.manage": "Planı yönet",
  "pricing.cta.upgradeTo": "{plan} planına yükselt",
  "pricing.cta.updated": "Aboneliğin güncellendi!",
  "pricing.error.generic":
    "Bir şeyler ters gitti. Lütfen destekle iletişime geç!",
  "pricing.seo.title": "Fiyatlar | Jammable",
  "pricing.seo.description":
    "İstediğin sesle AI cover yapmak için Jammable planları: sınırsız cover, indirme ve 93.000+ ses. Fiyatlar kendi para biriminde, istediğin zaman iptal et.",
};

export default pricing;
